import React from "react";
import "./styles.scss";
import { Row, Button } from "react-bootstrap";
import { reportFields } from "./helper";
import SolarField from "./SolarField";
import { formatNumber } from "../../util/helper-functions";

const SolarReportCard = ({ report }) => {
  const {
    savingsOver20Years,
    monthlyBill,
    averageSolarRadiation,
    roofSquareMeter,
  } = report;

  return (
    <div className="solar-report-card shadow">
      <h5> solar calculator </h5>
      <span className="solar-report-card__title  d-block"> Savings </span>
      <span className="solar-report-card__savings-value">
        {" "}
        ${formatNumber(savingsOver20Years)}
      </span>{" "}
      <span className="solar-report-card__remain-text"> over 20 years</span>
      <div className="form-area">
        <Row>
          {reportFields.map((field) => (
            <SolarField
              increaseDataPoint={() => {}}
              decreaseDataPoint={() => {}}
              key={field.id}
              field={field}
              data={{ monthlyBill, averageSolarRadiation, roofSquareMeter }}
            />
          ))}
        </Row>

        <div className="solar-report-btn-section">
          <Button
            variant="secondary"
            className=" btn-block solar-report-button"
          >
            {" "}
            Contact now{" "}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SolarReportCard;
